'use strict';

define('components/footer',[
  'jquery',
  'responsive',
  'lib/analytics/click',
  'lib/analytics/context.add',
  'lib/analytics/blocks/index',

  // side effect includes
  'bootstrapCollapse'
], function (
  $,
  responsive,
  anClicks,
  anAddContext,
  blocks
) {
  var footer = {
    load: function () {
      $('.js-footer-dropdown-mobile div.js-footer-head').on('click', function (e) {
        if (responsive() === 'sm') {
          e.preventDefault();
          var $this = $(this);
          var $childMenu = $this.next('ul');
          var $openMenus = $('.js-footer-dropdown-mobile').children('ul.footer-main-sub.in');
          // close any other sub-menus that may be open
          $('div.js-footer-head').not(this).removeClass('open');
          $('div.js-footer-head').not(this).attr('aria-expanded', 'false');

          if ($this.hasClass('open')) {
            $this.removeClass('open');
            $this.attr('aria-expanded', 'false');
          } else {
            $this.addClass('open');
            $this.attr('aria-expanded', 'true');
          }

          $openMenus.collapse('hide');
          // Toggle this one
          $childMenu.collapse('toggle');
        }
      });

      this.analyticsLoad();
    },

    analyticsLoad: function () {
      var $scope = $('div[data-component-name="Footer"]');
      anAddContext($scope, blocks.sectionBlock('Footer'));
      anClicks($scope);
    }
  };

  return footer;
});

